module.exports = __webpack_public_path__ + "img/logo-footer.67403926.svg";